import React, { Component } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Divider,
  DialogTitle
} from '@mui/material';
import { Info } from '@mui/icons-material';

import LocalStorageManager from '../managers/LocalStorageManager';
import PageDescription from '../components/PageDescription';

class AttentionToPricingAndOrdersPopup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            title: "",
            email: null,
            password: null,
            resetPassword: false
        }
    }

    handleShow = (title) => this.setState({ show: true, title });

    handleClose = () => {
        LocalStorageManager.Save("pageDescriptionConfirmed", "true");
        this.setState({ show: false });
    }

    componentDidMount() {
        if (LocalStorageManager.Get("pageDescriptionConfirmed") !== "true") {
            this.handleShow("Hinweis zu dieser Webseite und der Maro- Foodcoop");
        }
    }

    render() {
        return (
            <Dialog
                open={this.state.show}
                onHide={this.handleClose}
                backdrop="static"
                keyboard={false}
                maxWidth="md"
                fullWidth
                PaperProps={{
                  sx: {
                    borderRadius: { xs: '12px', sm: '20px' },
                    overflow: 'hidden',
                    margin: { xs: '16px', sm: '32px' },
                    maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' },
                    zIndex: 10000
                  }
                }}
            >
                {/* Header with gradient */}
                <Box
                  sx={{
                    background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
                    pt: { xs: 3, sm: 4 },
                    pb: { xs: 2.5, sm: 3 },
                    px: { xs: 2, sm: 3 },
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    gap: { xs: 1.5, sm: 2 }
                  }}
                >
                  <Info sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem' } }} />
                  <DialogTitle sx={{ p: 0, flex: 1 }}>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: 'white', fontSize: { xs: '1.1rem', sm: '1.5rem' } }}>
                      {this.state.title}
                    </Typography>
                  </DialogTitle>
                </Box>

                <DialogContent sx={{ pt: { xs: 2, sm: 3 }, pb: { xs: 1, sm: 2 }, px: { xs: 2, sm: 3 } }}>
                    <PageDescription greetings={true} />
                </DialogContent>

                <Divider />

                <DialogActions sx={{ p: { xs: 2, sm: 3 }, gap: 2, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      onClick={this.handleClose}
                      variant="contained"
                      size="large"
                      fullWidth
                      sx={{
                        bgcolor: '#2e7d32',
                        color: 'white',
                        fontWeight: 600,
                        textTransform: 'none',
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                        px: { xs: 2, sm: 4 },
                        py: { xs: 1.2, sm: 1.5 },
                        borderRadius: '10px',
                        boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                        '&:hover': {
                          bgcolor: '#1b5e20',
                          boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                          transform: 'translateY(-2px)'
                        },
                        transition: 'all 0.2s ease'
                      }}
                    >
                        Okay
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default AttentionToPricingAndOrdersPopup;
